"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCheckoutLineItemsDeliveryOptionsPath = exports.selectCheckoutLineItemsDeliveryOptions = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const selectCheckoutLineItemsDeliveryOptions = (client) => async ({ checkoutId, choices }) => {
    try {
        const response = await client.put((0, exports.selectCheckoutLineItemsDeliveryOptionsPath)(checkoutId), choices);
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.selectCheckoutLineItemsDeliveryOptions = selectCheckoutLineItemsDeliveryOptions;
const selectCheckoutLineItemsDeliveryOptionsPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/line-items`;
exports.selectCheckoutLineItemsDeliveryOptionsPath = selectCheckoutLineItemsDeliveryOptionsPath;
